const LEGACY_SHARED_COOKIE_NAME = 'answer_access_token';

function sharedCookieDomain(): string {
  if (typeof window === 'undefined') {
    return '';
  }
  const host = window.location.hostname.toLowerCase();
  if (host === 'localhost' || /^[0-9.]+$/.test(host) || host.includes(':')) {
    return '';
  }
  if (host === 'aiopentool.com' || host.endsWith('.aiopentool.com')) {
    return '; domain=.aiopentool.com';
  }
  return '';
}

function secureCookieFlag(): string {
  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    return '; Secure';
  }
  return '';
}

// Remove the historical JavaScript-readable bearer cookie. Answer now creates
// a host-only __Host-answer_agent_session cookie server-side with HttpOnly.
// The Domain variant below is deletion-only for installations that previously
// exposed answer_access_token to every aiopentool.com subdomain.
export function clearLegacyAnswerSharedSession() {
  if (typeof document === 'undefined') {
    return;
  }
  document.cookie = `${LEGACY_SHARED_COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax${secureCookieFlag()}`;
  const legacyDomain = sharedCookieDomain();
  if (legacyDomain) {
    document.cookie = `${LEGACY_SHARED_COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax${secureCookieFlag()}${legacyDomain}`;
  }
}
